import { useState } from "react";
import Typography from "@mui/material/Typography";
import { unpublishPurchaseOrders } from "../../services";
import { PurchaseOrderListItem } from "../../types/purchase-order.type";
import { numberWithCommas } from "../../utils";
import { pushGlobalSuccess } from "../../success/globalSuccess";
import ConfirmModal from "../ConfirmModal";

interface UnpublishDialogProps {
  open: boolean;
  /** ใบที่เลือกไว้และอาจอยู่ที่สาขาแล้ว (พร้อมใช้ / ยังไม่จับคู่ร้าน) */
  purchaseOrders: PurchaseOrderListItem[];
  onClose: () => void;
  onUnpublished: () => void;
}

/**
 * W1 ดึงกลับ — เอา PO ที่ส่งให้สาขาแล้วกลับมาที่ HO (สาขาและร้านยังอยู่ เซลส์เลือกไม่ได้แล้ว)
 * · 409 เมื่อมีใบที่ใช้แล้ว แจ้งด้วยข้อความไทยจาก API ผ่าน interceptor
 */
export default function UnpublishDialog({
  open,
  purchaseOrders,
  onClose,
  onUnpublished,
}: UnpublishDialogProps) {
  const [saving, setSaving] = useState<boolean>(false);

  const handleConfirm = async () => {
    setSaving(true);
    try {
      const {
        data: { data },
      } = await unpublishPurchaseOrders({
        uuids: purchaseOrders.map((row) => row.uuid),
      });
      if (data) {
        pushGlobalSuccess(
          `ดึงกลับจากสาขาแล้ว ${numberWithCommas(data.unpublished_count)} ใบ`,
        );
      }
      onUnpublished();
      onClose();
    } catch {
      // interceptor แจ้งข้อความจาก API แล้ว
    } finally {
      setSaving(false);
    }
  };

  return (
    <ConfirmModal
      title="ดึงกลับจากสาขา"
      description={`ดึง PO ${numberWithCommas(purchaseOrders.length)} ใบ กลับมาที่ HO`}
      open={open}
      loading={saving}
      confirmLabel="ดึงกลับ"
      confirmColor="warning"
      confirmDisabled={purchaseOrders.length === 0}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Typography variant="body2" color="text.secondary" mt={1}>
        สาขาจะไม่เห็นใบเหล่านี้และเซลส์เลือกใช้ไม่ได้จนกว่าจะส่งให้สาขาอีกครั้ง
        · ใบที่ยังไม่ได้ส่งให้สาขาจะถูกข้าม
      </Typography>
    </ConfirmModal>
  );
}
